<!--全局公共参数-->
<script>
  const api_url='/api';
  const edit_xml = 'http://daliapi.dxyj.top';
  //代理微博登录
  const weibo_url='http://ceshiklopruser28.kuleiman.com/agent/Login/wbLogin';
  //代理QQ登录
  const qq_url='http://sqi0315.kuleiman.com/agent/Login/qqLogin';
  //代理微信登录回调地址 agent/login/WechatLogin
  const wechat_url="http://sqi0315.kuleiman.com/agent/login/WechatLogin";
  //终端微博登录
  const member_weibo_url='http://ceshiklopruser28.kuleiman.com/member/Login/wbLogin';
  //终端QQ登录
  const member_qq_url='http://sqi0315.kuleiman.com/member/Login/qqLogin';
  //终端微信登录回调地址 member/login/WechatLogin
  const member_wechat_url="http://sqi0315.kuleiman.com/member/login/WechatLogin";
    //前端访问域名
  const qcdo_url="//daliyem.dxyj.top/";
  const qcdo_urlw="//daliyem.dxyj.top/";
  //PC微信扫码登录信息
  const pc_wechat={
    'app_id':'wx89ab2b943c6c69bc',
  };
  //PC微信扫码登录样式
  const pc_wechat_css="https://vr.kuleiman.com/Public/Member/login/css/wechat_login.css";
  const gltf_url='https://d3info.kuleiman.com/gltf.php';
  
  const SocketIO_url = 'https://daliapi.dxyj.top:2127';
  //全景登录xml 信息
  const login_pano_js="//imj.kuleiman.com/panosz.js";
  const login_pano_xml="https://vrr.kuleiman.com/App/Tpl/Member/Login/postprocessing_multipass_blur.xml";
  //前端访问域名


  const live_url = "https://daliyem.dxyj.top/";

  const upload_url = "//transact.kuleiman.com/"
  const amap_key_arr = [
        {key:'80f180c369144b1fe0955a0c1d0432e8' ,securityJsCode:'65a5be7ba51267ffebf25f1d000de919'},
        {key:'a09683154534a99b0e7c18c0d15819dc' ,securityJsCode:'f109c1a98afda87b06ef4b8d3272f383'},
        {key:'d4698bb6626217763f301a2f8835b3fc' ,securityJsCode:'c0d33ceb006080d5618712bcc4df62ee'},
        {key:'9c0948a9d68a54c0eb7f85bf2c9df30f' ,securityJsCode:'5fa7c715de03b2ca7331b051843ffea7'},
        {key:'d77f74c1ad2111fcc1fbd8fd93d2bb8c' ,securityJsCode:'ae0ac41f007c28acdbfc48056344b2fc'},
        {key:'9b28d57f275901fe9cd453bfb11045c3' ,securityJsCode:'4eb01c43ab7020424849135ea7999471'},
        {key:'01e2024ee9e05a4d2298f73a02aa2221' ,securityJsCode:'2ab33443d6eb25eaaebd18af3335792e'},
        {key:'1f8cfc13653258230b3e1dc0a40357a4' ,securityJsCode:'2fd8ca291f6ab8ac5bd9a25c88e2160f'},
        {key:'1ff505f264bc8a4320c31ce5065a4c69' ,securityJsCode:'f6599f27c097b8d22bf57d1f64b75a7e'},
  ];
  let random_num = parseInt(Math.random()*amap_key_arr.length);
  const amap_key= amap_key_arr[random_num].key;
  const amap_securityJsCode= amap_key_arr[random_num].securityJsCode;
  
    const staticmap_key_arr = [
        {key:'6c3dddf92bc1aafd14961ef116117eba'},
        {key:'648f96b398f35d4db2b3820fc8fb674b'},
        {key:'5807ea246f8a84c15bfae15e2f41edbd'},
        {key:'781def049df4de3cf5e986011251741a'},
        {key:'13c30906ebf6f9a5a4ccface4ec9606e'},
        {key:'626d494985c148bb1d9380419b1971d7'},
        {key:'dfc642cc8901d10a4f1e14162fa81dd6'},
        {key:'5aff98ffe9ea6028e623c438bd1a71ac'},
        {key:'9513eae2f804aa002511f2defe7f1f37'},
    ];
  
  const staticmap_key = staticmap_key_arr[parseInt(Math.random()*staticmap_key_arr.length)].key;
  
  //全图上传地址
  const pano_url = window.location.origin;
  const checkPhone = (rule, value, callback) => {
    if (!value) {
      return callback(new Error('手机号不能为空'));
    } else {
      const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error('请输入正确的手机号'));
      }
    }
  };
  const verify_phone=(value)=>{
      var reg01 =
              /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;
      var reg02 =
              /^09\d{8}$/;
      var reg03 =
              /^(008529|008526|008525)\d{7}$/;
      var reg04 =
              /^(0049)\d{11}$/;
      var reg05 =
            /^(0081|0066)\d{10}$/;
      var reg06 =
          /^01\d{9}$/;

      if(!reg01.test(value) && !reg02.test(value) && !reg03.test(value)&& !reg04.test(value)&& !reg05.test(value)&& !reg06.test(value)){
         return false;
      }
      return true;
  }
  const public_key="kkllmm";
  const icoycopyright= 'Copyright @'+new Date().getFullYear()+' 北京同创蓝天云科技有限公司版权所有 服务热线：400-0440-578 京ICP备15037671号';

  //去除俩边的空格
  function trim(str){ //删除左右两端的空格
    return str.replace(/(^\s*)|(\s*$)/g, "");
  }
  function IsURL (str_url) {
    // var strRegex = '^((https|http|ftp|rtsp|mms)?://)'
    //   + '?(([0-9a-z_!~*\'().&=+$%-]+: )?[0-9a-z_!~*\'().&=+$%-]+@)?' //ftp的user@
    //   + '(([0-9]{1,3}.){3}[0-9]{1,3}' // IP形式的URL- 199.194.52.184
    //   + '|' // 允许IP和DOMAIN（域名）
    //   + '([0-9a-z_!~*\'()-]+.)*' // 域名- www.
    //   + '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' // 二级域名
    //   + '[a-z]{2,6})' // first level domain- .com or .museum
    //   + '(:[0-9]{1,4})?' // 端口- :80
    //   + '((/?)|' // a slash isn't required if there is no file name
    //   + '(/[0-9a-z_!~*\'().;?:@&=+$,%#-]+)+/?)$';
      var strRegex = '^((https|http|ftp|rtsp|mms)?://)'
    var re=new RegExp(strRegex);
    //re.test()
    if (re.test(str_url)) {
      return (true);
    } else {
      return (false);
    }
  }

  function str_en_cn_length(str){
    let sum = 0 ,i = 0;
    for (; i < str.length; i++){
        if((str.charCodeAt(i) >=0) && (str.charCodeAt(i) <= 255)){
            sum += 1
        }else {
            sum += 2
        }
    }
    return sum
}

function cutstr(str, len) {
    var strLen = str.length;
    var strCut = '';
    var strLength =0;
    for(let i=0;i<strLen;i++){
        var charStr = str.charAt(i); //使用charAt获取单个字符；
        strLength++
        if(encodeURI(charStr).length>4){ //使用encodeURI获取编码长度
            strLength++;
        }
        if(strLength <= len){
            strCut = strCut.concat(charStr);//单个字符进行合并
        }
        if(strLength >= len){
            //strCut = strCut.concat('...') //大于指定长度后合并'...'并返回此字符串
            return strCut;
        }

    }
    if(strLength<len){
        return str
    }
}
const data_public_key = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC6M4MVmhK5S/q5gvqOS6Nl0mD/
a4s0qY4KeYBK6zFw35m5TIx5YnctiykwTTGOO4hP00eYsCywmYg557uGFmWidrEV
fkODXJasPEa8k39zvcVgazzpdn/GCuuIuxM13Tz2UtRYr4caUE8o2rIc6EV8hOr4
MoN+gpiI/NxO23IFWQIDAQAB
-----END PUBLIC KEY-----`;

const origin_urlingo = {
    "酷开8KVR":{
        host:"http://pano-play.coocaa.com/",
        live:""
    },
    "顾达优选":{
        host:"http://www.xn--4oqy98mqga722a.com/",
        live:"http://live.xn--4oqy98mqga722a.com/"
    },
    "创世新动科技文化发展（北京）有限公司":{
        host:"https://www.csyvr.com/",
        live:"https://live.csyvr.com/"
    },
    "智控领域（北京）物联网科技有限公司":{
        host:"http://zkly.cxvk.com.cn/",
        live:"http://zklycfy.cxvk.com.cn/"
    },
    "渲色3DVR全景营销系统":{
        host:"https://www.xuansevr.com/",
        live:"https://live.xuansevr.com/"
    },
    "Ta 视角":{
        host:"https://vr.liugetech.com/",
        live:"https://live.liugetech.com/"
    },
};

export default {
   // kmap_xml,//酷客导航xml的地址
    api_url,//api地址
      edit_xml,
    qq_url,//QQ登录
    weibo_url,//微博登录
    wechat_url,//微信
    member_weibo_url,//终端微博登录
    member_qq_url,//终端QQ登录
    member_wechat_url,
    qcdo_url,
    qcdo_urlw,
    pc_wechat,
    pc_wechat_css,
    SocketIO_url,
    login_pano_js,
    login_pano_xml,
    pano_url,
    checkPhone,
    verify_phone,
    public_rules:{
      required:{
        required: true,
        message: '请输入字段名称',
        trigger: 'change'
      },
      mail:[{
        required: true,
        message: '请输入邮箱',
        trigger: 'change'
      }, {
        type: 'email',
        message: '请输入正确的邮箱地址',
        trigger: 'change'
      }],
      phone:[{
        required: true,
        message: '请输入手机号码',
        trigger: 'change'
      },
        {validator: checkPhone, trigger: 'change' }
      ],
    },
    trim,
    IsURL,upload_url,
    public_key,
    icoycopyright,
    str_en_cn_length,
    cutstr,
    data_public_key,
    amap_key,
    amap_securityJsCode,
    staticmap_key,
    gltf_url,   //模型脚本文件
    origin_urlingo,
}
</script>



// WEBPACK FOOTER //
// src/GLOBAL.vue